/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, November 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const MultiDropDown = ({
  options,
  value,
  closeMenuOnSelect,
  placeholder,
  onChange,
  width,
}) => {

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'white',
      color: 'white',
      borderColor: state.isFocused ? 'gray' : 'gray',
      boxShadow: state.isFocused ? null : null,
      width: `${width}vw`,
      height: '5.25vh',
      minHeight: '5.25vh',
      borderRadius: '0vh',
      borderColor: '#a4a4a4',
      borderWidth: '0.1vh',
      '&:hover': {
        borderColor: state.isFocused ? 'gray' : 'gray'
      },
      overflow: 'scroll',
      fontSize: '2vh',
    }),
    valueContainer: (base, state) => ({
      ...base,
      padding: '0 0.2vw',
      color: 'red'
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '2vh',
      color: 'black',
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '2vh',
      padding: '0.6vh 1.3vw',
      backgroundColor: state.isSelected ? 'white' : 'white',
      color: state.isSelected ? 'black' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? 'rgb(222, 235, 255)' : 'rgb(222, 235, 255)'
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '0px',
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '0px',
    }),
  };

  return (
    <Select
      options={options}
      isMulti={true}
      value={value ? value : null}
      closeMenuOnSelect={closeMenuOnSelect}
      // components={animatedComponents}
      styles={customStyles}
      placeholder={placeholder}
      onChange={onChange}
      isSearchable={false}
    />
  );
};

export default MultiDropDown;

MultiDropDown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  closeMenuOnSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.number,
};

MultiDropDown.defaultProps = {
  options: [],
  value: null,
  closeMenuOnSelect: false,
  placeholder: 'Please Select',
  onChange: () => { },
  width: 20,
};
